import React from 'react';
import { UseCampanhaTableContext } from 'context/campanha-context';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faEllipsisH } from '@fortawesome/free-solid-svg-icons';
import { ButtonStyled } from './style';

library.add(faEllipsisH);

interface Props {
  ariaLabel: string;
  setOpenPopover: (open: boolean) => void;
}

function ButtonPopover({
  ariaLabel = 'Abrir ações da campanha',
  setOpenPopover,
}: Props) {
  const { setAnchorEl } = UseCampanhaTableContext();

  const handleClick = (event) => {
    setOpenPopover(true);
    setAnchorEl(event.currentTarget);
  };

  return (
    <ButtonStyled aria-label={ariaLabel} onClick={handleClick} type="button">
      <FontAwesomeIcon icon="ellipsis-h" size="2x" color="#bbc8db" />
    </ButtonStyled>
  );
}

export default ButtonPopover;
